<template lang="pug">
	.publisher-list
		.page-center-content
			.caption-area Publisher list
			.publishers-table
				DataTable(entity="publishers" :fields="fields" key-field="id" :sort="['create_date', 'desc']" :update-on="['Layout Page Showed:publisher-list']" focus-on="Layout Page Showed:publisher-list" :height-offset="Layout.headerHeight + 45")

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Layout } 			from './../../services/Layout'
	import { Publisher } 		from './../../services/Publisher'
	import { User } 			from './../../services/User'

	import DataTable			from './../../components/Templates/DataTable'

	export default {
		name: "PublisherList",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Publisher Changed", "Layout Page Showed:publisher-list"]
		},
		components: {
			DataTable
		},
		data() {

			this.Publisher = Publisher;
			this.User = User;

			this.fields = [
				{
					fieldName: 'id',
					title: 'ID',
					type: 'number',
					display: true,
					click: this.publisherClick,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '70px'
				},
				{
					fieldName: 'codename',
					title: 'Codename',
					type: 'string',
					display: true,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '250px'
				},
				{
					fieldName: 'title',
					title: 'Title',
					type: 'string',
					display: true,
					click: this.publisherClick,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '250px'
				},
				{
					fieldName: 'create_date',
					title: 'Creation date',
					type: 'date',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					width: '150px'
				},
				{
					fieldName: 'last_activity_time',
					title: 'Last activity',
					type: 'date',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					width: '150px'
				},
				{
					fieldName: 'options',
					title: 'Options',
					type: 'object',
					display: false,
					filteringAllowed: false
				},
				{
					fieldName: 'active',
					title: 'Active',
					type: 'boolean',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					editAllowed: true,
					onChange: this.activatePublisher,
					width: '90px'
				},
				{
					title: '',
					type: 'buttons',
					buttons: [{
						class: 'btn-ghost-secondary',
						icon: 'fa-cog',
						title: '',
						click: this.openPublisherSettings
					}],
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					editAllowed: true,
					width: '80px'
				}
			];

			return {
				showed: true
			}

		},
		methods: {
			collectData() {

			},
			publisherClick(publisher) {

				//Номер ноды передаём вместе с id: id издателей на разных нодах могут совпадать
				Layout.setPage('publisher-settings', {publisherId: publisher.id, serverId: publisher.server_id, backPage: [Layout.page, Layout.pageOptions]});

			},
			activatePublisher(publisher) {

				Server.sendToSocket({
					SetPublisherStatus: {
						publisherId: publisher.id,
						active: publisher.active
					}
				})

			},
			openPublisherSettings(publisher) {

				//Номер ноды передаём вместе с id: id издателей на разных нодах могут совпадать
				Layout.setPage('publisher-settings', {publisherId: publisher.id, serverId: publisher.server_id, backPage: ['publisher-list', {}]});

			}
		}
	}
</script>

<style lang="sass" scoped>

	.publisher-list
		display: flex !important
		justify-content: center
		color: #fff

		.page-center-content
			width: 100%
			max-width: 1000px
			height: fit-content
			min-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)

			.caption-area
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)
				padding: 0.7rem 1rem

			.publishers-table
				display: flex
				flex-direction: row
				flex-wrap: wrap
				padding: 1rem 0

</style>

